// extracted by mini-css-extract-plugin
module.exports = {"videoEmbed":"MediaEmbed_videoEmbed__3B0D-","audioEmbed":"MediaEmbed_audioEmbed__KZWRy","tweetEmbed":"MediaEmbed_tweetEmbed__ITxVt"};